<mat-form-field [appearance]="appearance" [class.noHints]="noHints" [appTailwindMaterial]="tailwindClasses">
    <mat-label [ngClass]="classList" *ngIf="placeholder" [title]="placeholder">{{ placeholder }}</mat-label>
    <input
        [type]="'text'"
        [dir]="dir"
        autocomplete="off"
        [autofocus]="autofocus"
        matInput
        [name]="name"
        [title]="title || placeholder"
        [id]="id"
        [ngClass]="classList"
        [formControl]="control"
        [errorStateMatcher]="matcher"
        [debounce]="debounceAfter || 1000"
        (eventHandler)="debounceEventHandler.emit($event)"
        (keyup)="clearErrors(); keyUpEventHandler.emit($event)"
        (keypress)="clearErrors()"
        (blur)="onBlur($event)"
        (focus)="onFocus()" />

    <material-button
        *ngIf="control.value && control.value.length > 0 && disabled !== true && needIcon && !(errors && errors.length > 0)"
        matSuffix
        buttonType="icon"
        prefixIcon="done"
        prefixIconType="material"
        color="default"
        size="small"></material-button>
    <material-button
        *ngIf="noHints || (description && description.length > 0)"
        matSuffix
        buttonType="icon"
        prefixIcon="info"
        prefixIconType="material"
        color="default"
        size="small"
        [titleText]="noHints ? errors?.[0] || warnings?.[0] || description : description"></material-button>
    <material-button
        *ngIf="showClearText"
        matSuffix
        buttonType="icon"
        prefixIcon="close"
        prefixIconType="material"
        color="default"
        size="small"
        (buttonClicked)="control.setValue('')"
        [disabled]="!control?.value?.length"></material-button>
    <mat-hint align="end" *ngIf="maxLength && !noHints">
        <span [textContent]="(control.value && control.value.length) || 0"></span>
        /
        <span [textContent]="maxLength"></span>
    </mat-hint>
    <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0) && !noHints">
        <strong *transloco="let translate" class="mr-2">
            <span>*</span>
            <span [textContent]="translate('required')"></span>
        </strong>
    </mat-hint>
    <mat-hint align="start" *ngIf="!(errors && errors.length > 0) && hint && hint.length > 0 && !noHints">
        <span *ngIf="required" class="mr-2">&</span>
        <span [textContent]="hint"></span>
    </mat-hint>
    <mat-error *ngIf="errors && errors.length > 0" [title]="errors">
        <span [textContent]="errors"></span>
    </mat-error>
</mat-form-field>
